// src/App.js
import React from 'react';
import './App.css';
import CodeEditor from './CodeEditor';

function App() {
  return (
    <div className="App">
      <h1>JavaScript Code Editor with Compilation and Solutions</h1>
      <CodeEditor />
    </div>
  );
}

export default App;
